import { createAsyncTypes } from 'utils/ActionCreator'

export const WHITELIST_GET_ASYNC = createAsyncTypes('WHITELIST_GET', 'Settings/Whitelist')
export const WHITELIST_DELETE_SELECTED_ASYNC = createAsyncTypes(
  'WHITELIST_DELETE_SELECTED',
  'Settings/Whitelist'
)
export const WHITELIST_ADD_ASYNC = createAsyncTypes('WHITELIST_ADD', 'Settings/Whitelist')
export const WHITELIST_EDIT_ASYNC = createAsyncTypes('WHITELIST_EDIT', 'Settings/Whitelist')

export const WHITELIST_SELECT_TOGGLE = 'Settings/Whitelist/WHITELIST_SELECT_TOGGLE'
export const WHITELIST_SELECT_ALL = 'Settings/Whitelist/WHITELIST_SELECT_ALL'
export const WHITELIST_UNSELECT_ALL = 'Settings/Whitelist/WHITELIST_UNSELECT_ALL'

export const BY_COMPANY_TYPE_FILTER_CHANGE = 'Settings/Whitelist/BY_COMPANY_TYPE_FILTER_CHANGE'
export const BY_COMPANY_SORT_PROPERTY_CHANGE = 'Settings/Whitelist/BY_COMPANY_SORT_PROPERTY_CHANGE'

export const WHITELIST_PAGE_CHANGE = 'Settings/Whitelist/WHITELIST_PAGE_CHANGE'
export const WHITELIST_SEARCH_FILTER_CHANGE = 'Settings/Whitelist/WHITELIST_SEARCh_FILTER_CHANGE'

export const WHITELIST_TABLE_DEFAULT_PAGE_SIZE = 50

export const WHITELIST_TYPES = {
  IP: 1,
  DOMAIN: 2,
  ADDRESS: 3,
  LINKS: 4,
}

export const MAP_WHITELIST_TYPE_TO_NAME = {
  1: 'IP',
  2: 'Domain',
  3: 'Address',
  4: 'Links',
}

export const whitelistTypes = [
  {
    value: WHITELIST_TYPES.IP,
    label: MAP_WHITELIST_TYPE_TO_NAME[WHITELIST_TYPES.IP],
  },
  {
    value: WHITELIST_TYPES.DOMAIN,
    label: MAP_WHITELIST_TYPE_TO_NAME[WHITELIST_TYPES.DOMAIN],
  },
  {
    value: WHITELIST_TYPES.ADDRESS,
    label: MAP_WHITELIST_TYPE_TO_NAME[WHITELIST_TYPES.ADDRESS],
  },
]

export const WHITELIST_FOR_TYPES = {
  ALL_CAPABILITIES: 1,
  IMPERSONATION_PROTECTION: 2,
  LINKS: 3,
  SPAM: 4,
  BYPASS_ALL_LINKS: 6,
}

export const mapPlaceholderByType = {
  [WHITELIST_TYPES.IP]: '100.100.100.100 or 8.8.8.8/28',
  [WHITELIST_TYPES.DOMAIN]: 'example.com or *.example.com',
  [WHITELIST_TYPES.LINKS]: 'example.com or *.example.com',
  [WHITELIST_TYPES.ADDRESS]: 'sender@example.com',
}

export const TABS_INDICES = {
  LINKS_SECTION: 1,
  EMAILS_SECTION: 0,
}

const BYPASS_ALL_SCAN_TEXT =
  'This ensures that links are completely bypassed from all scanning processes, including analysis by IRONSCALES and threat intelligence vendors.'

export const MAP_WHITELIST_FOR_TO_LABEL = {
  [WHITELIST_FOR_TYPES.ALL_CAPABILITIES]: {
    title: 'Skip All Inspections',
    text: 'Emails from this item will bypass all inspections, including spam, phishing, and malicious content detection.',
    showCheckboxesSection: true,
    id: 'whitelistFor_allCapabilities',
  },
  [WHITELIST_FOR_TYPES.IMPERSONATION_PROTECTION]: {
    title: 'Bypass Impersonation Banners',
    text: 'Emails from this item will not trigger impersonation alerts or display ‘First-time sender’ banners.',
    showCheckboxesSection: true,
    id: 'whitelistFor_impersonationProtection',
  },
  [WHITELIST_FOR_TYPES.SPAM]: {
    title: 'Skip Spam Filtering',
    text: 'Emails from this item will bypass spam filtering and will not be flagged as spam.',
    id: 'whitelistFor_spam',
  },
  [WHITELIST_FOR_TYPES.LINKS]: {
    title: 'Bypass link from being clicked',
    text: 'These links will not be scanned for any malicious content.',
  },
  [WHITELIST_FOR_TYPES.BYPASS_ALL_LINKS]: {
    title: 'Bypass all scans',
    text: BYPASS_ALL_SCAN_TEXT,
  },
}

const ADD_ALLOWED_LINKS_NEW_TYPES = {
  BYPASS_ALL: 0,
  BYPASS_LINKS: 1,
}

export const MAP_NEW_ALLOWED_LINKS_OPTIONS = {
  [ADD_ALLOWED_LINKS_NEW_TYPES.BYPASS_ALL]: {
    title: 'Bypass all scanning for links',
    text: BYPASS_ALL_SCAN_TEXT,
    scope: 6,
    key: 'Bypass-all-option',
  },
  [ADD_ALLOWED_LINKS_NEW_TYPES.BYPASS_LINKS]: {
    title: 'Bypass link clicking by IRONSCALES',
    text: 'This ensures that links are bypassed from being clicked by IRONSCALES scanners while still being sent to threat intelligence vendors for thorough analysis and scanning.',
    scope: 3,
    key: 'Bypass-link-option',
  },
}
